/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext } from 'react';
import { getHumanReadableMeetingId } from '../../../lib/meetingIdFormatter';
import { defineMessages, useIntl } from 'react-intl';
import { SessionContext } from '../../../context/SessionContext';
import { Flex, Text } from '@getgo/chameleon-chakra-ui';

const messages = defineMessages({
  haveTheApp: {
    id: 'firstJoinNative.selfHelp1',
  },
  useMeetingId: {
    id: 'firstJoinNative.selfHelp2',
  },
});

export const HaveTheApp: React.FC = () => {
  const { meetingId } = useContext(SessionContext);
  const { formatMessage: f } = useIntl();
  if (!meetingId) {
    return null;
  }
  return (
    <Flex mb={4} id='alreadyHaveTheApp'>
      <Text>
        {f(messages.haveTheApp)}
        <br />
        {f(messages.useMeetingId)} <b>{getHumanReadableMeetingId(meetingId)}</b>
      </Text>
    </Flex>
  );
};
